import { AxiosInstance } from 'axios';
import { HealthCheckResponse } from '../types/health';
import { HealthCheckResponseSchema } from '../z/health';

export class HealthClient {
  constructor(
    private readonly http: AxiosInstance
  ) {}

  /**
   * Check the health status of the Gamma API.
   * 
   * This endpoint returns the current status of the API, including uptime,
   * version information, and timestamp of the last health check.
   * 
   * @example
   * ```typescript
   * const health = await client.health.check();
   * console.log('API Status:', health.status);
   * console.log('Uptime:', health.uptime);
   * ```
   * 
   * @returns Promise<HealthCheckResponse> - Health check response containing status, timestamp, version, and uptime
   * @throws {Error} When the API request fails or returns invalid data
   * 
   * @see {@link https://docs.polymarket.com/api-reference/health/health-check} - API Documentation
   */
  async check(): Promise<HealthCheckResponse> {
    try {
      const response = await this.http.get('/health');
      const validatedData = HealthCheckResponseSchema.parse(response.data);
      
      return validatedData;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Health check failed: ${error.message}`);
      }
      throw error;
    }
  }
}
